import { render, staticRenderFns } from "./DeleteEstimateModal.vue?vue&type=template&id=08924626&scoped=true"
import script from "./DeleteEstimateModal.vue?vue&type=script&lang=js"
export * from "./DeleteEstimateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08924626",
  null
  
)

export default component.exports